import Slider from "react-slick";
import { Rating } from 'react-simple-star-rating';
import { useEffect, useState } from "react";
import { get } from "../../_services/apiService";
import { API_URL } from "../../_services/apiUrl";
import { FaUser } from 'react-icons/fa';

const CustomerSaySection = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const [productRating, setProductRating] = useState([]);

    const GetProductRating = async () => {
        try {
            setLoading(true);
            const response = await get(API_URL?.GetProductRating);
            if (response.isSuccess === 200) {
                setProductRating(response?.data);
            } else {

            }
        } catch (error) {
            setError('Rating not Avaiable');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        GetProductRating();
    }, []);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        autoplay: false,
        autoplaySpeed: 2000,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                },
            },
            {
                breakpoint: 572,
                settings: {
                    slidesToShow: 1
                },
            }
        ],
    };

    if (loading) return <div>loading...</div>;

    return (
        <>
            {productRating?.length > 0 && (
                <section className="customer_say_weepr">
                    <div className="hedding">
                        <h2>What Our Customer Say</h2>
                    </div>
                    <div className="container">
                        {productRating?.length > 1 ? (
                            <div className="row justify-content-center">
                                <Slider {...settings}>
                                    {productRating?.map((item, index) => (
                                        <div className="same_width" key={index}>
                                            <div className="customer_wepper">
                                                <h2>{item?.userName}</h2>
                                                <p>
                                                    "{item?.remark}"
                                                </p>
                                                <div className="star_inner">
                                                    <Rating
                                                        initialValue={item?.ratting}
                                                        readonly
                                                        size={22}
                                                        label={`Rating: ${5}`}
                                                        fractions={2}
                                                    />
                                                </div>
                                            </div>
                                            <div className="customer_icon_wepper">
                                                <div className="customer_inner">
                                                    <div className="d-flex justify-content-center customer_icon">
                                                        {/* <img src="images/customer.png" alt="Hand-stitched chikankari kurta – Gailee" /> */}
                                                        <FaUser size={32} />
                                                    </div>
                                                    <div className="customer_line">
                                                        <img src="images/customer-line.svg" alt="Hand-stitched chikankari kurta – Gailee" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        ) : (
                            <div className="row justify-content-center">
                                {productRating?.map((item, index) => (
                                    <div className="col-md-4 col-sm-6 col-12" key={index}>
                                        <div className="customer_wepper">
                                            <h2>{item?.userName}</h2>
                                            <p>
                                                {/* <img src="images/quotation-mark.svg" alt="Hand-stitched chikankari kurta – Gailee" width="20" /> */}
                                                "{item?.remark}"
                                                {/* <img src="images/quotation-mark1.svg" alt="Hand-stitched chikankari kurta – Gailee" width="20" /> */}
                                            </p>
                                            <div className="star_inner">
                                                <Rating
                                                    initialValue={item?.ratting}
                                                    readonly
                                                    size={22}
                                                    label={`Rating: ${5}`}
                                                    fractions={2}
                                                />
                                            </div>
                                        </div>
                                        <div className="customer_icon_wepper">
                                            <div className="customer_inner">
                                                <div className="d-flex justify-content-center customer_icon">
                                                    {/* <img src="images/customer.png" alt="Hand-stitched chikankari kurta – Gailee" /> */}
                                                    <FaUser size={32} />
                                                </div>
                                                <div className="customer_line">
                                                    <img src="images/customer-line.svg" alt="Hand-stitched chikankari kurta – Gailee" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </section>
            )}
        </>
    )
}

export default CustomerSaySection;